module.exports = __webpack_public_path__ + "static/img/school-2.40509fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/school-2.png
// module id = VWVV
// module chunks = 1